// TODO: this should be deprecated in favor of direct imports of service modules
import AnalyticsService from './AnalyticsService';
import AuthService from './AuthService';
import ApplePayService from './ApplePayService';
import BBBService from './BBBService';
import CheckoutService from './CheckoutService';
import MenuService from './MenuService';
import OrderService from './OrderService';
import RewardsService from './RewardsService';
import StoreService, { AddressQuery } from './StoreService';
import UserService from './UserService';
import client, { ApiError, isApiError } from './client';

export type { AddressQuery };
export type { ApiError };

export {
    AnalyticsService,
    AuthService,
    ApplePayService,
    BBBService,
    CheckoutService,
    MenuService,
    OrderService,
    RewardsService,
    StoreService,
    UserService,
    client,
    isApiError
};
